import React from "react";
import { Navbar, Nav, Container, NavDropdown } from "react-bootstrap";
import { FaWarehouse, FaUserCircle } from "react-icons/fa";
import "./Navbar.css";
import 'bootstrap/dist/css/bootstrap.min.css';
import { useNavigate } from "react-router-dom";

const TopNavbar = () => {
  const navigate = useNavigate();

  const handleLogout = () => {
    sessionStorage.clear();
    navigate('/');
  };

  return (
    <Navbar variant="dark" expand="lg" sticky="top" className="shadow-sm" style={{position:"absolute",width:"100%",right:0,padding:"0px",background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)"}} >
      <Container fluid>
        {/* Logo + Brand */}
        <Navbar.Brand
          onClick={() => {
            try {
              const user = JSON.parse(sessionStorage.getItem("user2"));
              const uname = (user?.username || "").toLowerCase();

              if (uname === "vinod" || uname === "bhawesh" || uname === "krishna" || uname==="admin") {
                navigate("/employeesearch");
              }
              // ❌ else do nothing (no redirect)
            } catch (e) {
              console.error("Session parse error:", e);
            }
          }}
          className="fw-bold d-flex align-items-center"
        >
          <FaWarehouse className="me-2 fs-4" />
          Asset Management Portal
        </Navbar.Brand>

        {/* Toggle Button for Mobile */}
        <Navbar.Toggle aria-controls="basic-navbar-nav" />

        {/* Navbar Links */}
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="mx-auto">
            {/* <Nav.Link href="/dashboard" className="fw-semibold">Dashboard</Nav.Link> */}
            <Nav.Link onClick={()=>navigate("/addasset1")} className="fw-semibold">Asset Entry</Nav.Link>
            <Nav.Link
              href={
                (() => {
                  try {
                    const user = JSON.parse(sessionStorage.getItem("user2"));
                    return user?.admin_type === "Admin" ? "/admin-assets-summary" : "/myassets";
                  } catch {
                    return "/myassets";
                  }
                })()
              }
              className="fw-semibold"
            >
              View Entry
            </Nav.Link>

            {(() => {
              try {
                const user = JSON.parse(sessionStorage.getItem("user2"));
                return user?.username?.toLowerCase() === "bhawesh" ? (
                  <Nav.Link onClick={() => navigate("/quarterly-mail-panel")} className="fw-semibold">
                    📬 Mail Schedule
                  </Nav.Link>
                ) : null;
              } catch {
                return null;
              }
            })()}

            {/* 
            <Nav.Link href="/reports" className="fw-semibold">Reports</Nav.Link>
            <Nav.Link href="/settings" className="fw-semibold">Settings</Nav.Link> */}
          </Nav>

          {/* Right-side Profile Dropdown */}
          <Nav>
            <NavDropdown
              title={
                <span className="d-flex align-items-center text-white">
                  <FaUserCircle className="me-1 fs-5" />
                  {JSON.parse(sessionStorage.getItem("user2"))?.username}
                </span>
              }
              id="basic-nav-dropdown"
              align="end"
              menuVariant="dark"
            >
              <NavDropdown.Item onClick={() => navigate("/change-password")}>
                <i className="fa-solid fa-key me-2"></i>
                Change Password
              </NavDropdown.Item>
              <NavDropdown.Divider />
              <NavDropdown.Item onClick={handleLogout}>
                <i className="fa-solid fa-sign-out-alt me-2"></i>
                Logout
              </NavDropdown.Item>
            </NavDropdown>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default TopNavbar;